import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import ImgCard from '../ImgCard';
import sustainability from '../../mockData/sustainability';
import { COLOR_CORAL, COLOR_RED_VISITED } from '../../utils/constants';

const useStyles = makeStyles({
  container: {
    justifyContent: 'space-between',
    marginTop: 80,
    marginBottom: 40,
    '@media (max-width:600px)': {
      marginTop: 40,
      marginBottom: 0,
    },
  },
  imageGrid: {
    padding: '0px 0px 0px 140px',
    alignSelf: 'flex-end',
    '@media (max-width:900px)': {
      padding: '0px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '0px 0px 20px 0px',
    },
  },
  textGrid: {
    padding: '0px 0px 0px 160px',
    maxWidth: 720,
    '& a': {
      color: COLOR_CORAL,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
        textDecorationColor: COLOR_CORAL,
      },
      '&:visited': {
        color: COLOR_RED_VISITED,
      },
    },
    '@media (max-width:1024px)': {
      padding: '20px 0px 40px 100px',
    },
    '@media (max-width:900px)': {
      padding: '20px 0px 40px 50px',
    },
    '@media (max-width:600px)': {
      padding: '20px 20px 20px 20px',
    },
  },
});

const SustainabilityPage = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Grid item sm={6} className={classes.textGrid}>
        <h3 style={{ marginTop: 0 }}>Sustainable Development Goals</h3>
        <p>
          Our entire business is built on the fundamental belief that we need to
          take better care of the world. We provide technology and solutions
          that enable our customers to manage their waste and energy challenges
          in a sustainable manner.
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://sustainabledevelopment.un.org/sdgs"
          >
            The United Nations’ Sustainable Development Goals
          </a>
          (SDG) guide us in our work. The SDGs is a collection of 17 goals set
          by the United Nations. Each goal has a separate list of targets to
          achieve, and achieving all 169 targets, the 17 SDGs will be met. The
          SDG are a global call of action to end poverty, protect the planet and
          ensure that all people enjoy peace and prosperity. In Vow we are
          working to meet several of these goals.
        </p>
      </Grid>
      <Grid item sm={6} className={classes.imageGrid}>
        <Grid container spacing={2}>
          {sustainability.map(item => (
            <Grid item sm={12}>
              <ImgCard {...item} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SustainabilityPage;
